import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
export type ModalType =
  | "signin"
  | "signup"
  | "recovery"
  | "withdraw"
  | "deposit"
  | "bank"
  | "recoveryPassword"
  | "language"
  | "affiliateRegister"
  | "uplineContact"
  | "notify_VBOS"
  | "";

export interface ModalStateType {
  openModal: ModalType;
  openSidebar: boolean;
  modalProps: Record<string, any>;
}

type OpenModalPayload =
  | ModalType
  | {
      key: ModalType;
      props?: Record<string, any>;
    };

export const initialState: ModalStateType = {
  openModal: "",
  openSidebar: false,
  modalProps: {},
};
const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setOpenModal: (state, action: PayloadAction<OpenModalPayload>) => {
      // Case cũ: dispatch(setOpenModal("recoveryPassword"))
      if (typeof action.payload === "string") {
        state.openModal = action.payload;
        state.modalProps = {};
        return;
      }

      // Case mới: dispatch(setOpenModal({ key, props }))
      state.openModal = action.payload.key;
      state.modalProps = action.payload.props ?? {};
    },
    setOpenSidebar: (state: ModalStateType, action: PayloadAction<boolean>) => {
      state.openSidebar = action.payload;
    },
  },
});
export const selectOpenModal = (state: ApplicationRootState) =>
  state.modal.openModal;
export const selectModalProps = (state: ApplicationRootState) =>
  state.modal.modalProps;
export const selectOpenSidebar = (state: ApplicationRootState) =>
  state.modal.openSidebar;
export const { setOpenModal, setOpenSidebar } = modalSlice.actions;
export default modalSlice.reducer;
